import { ProcessedTextElement } from "@app/types/Opensearch";
import ApplyParagraphAnnotations from "@elements/ArticleParagraph/ApplyParagraphAnnotations";
import { twMerge } from "tailwind-merge";

type PullQuoteCardProps = {
  quote: ProcessedTextElement;
  quotee: ProcessedTextElement;
  quoteLabel: ProcessedTextElement | undefined;
  quoteCredit: ProcessedTextElement | undefined;
};

export default function PullQuoteCard({
  quote,
  quotee,
  quoteLabel,
  quoteCredit,
}: PullQuoteCardProps) {
  const flexCol = "flex flex-col";

  return (
    <div
      className={twMerge(
        "w-full md:w-[600px] mx-auto gap-2 lg:gap-3 mb-8 text-neutral-700",
        flexCol,
      )}
    >
      {quoteLabel && quoteLabel.value && (
        <div className="font-bold text-sm lg:text-md">
          {ApplyParagraphAnnotations(quoteLabel.value, quoteLabel.annotations)}
        </div>
      )}
      <div className={twMerge("lg:gap-5 pb-3", flexCol)}>
        <p className="font-secondary text-[160px] lg:text-[220px] text-blue-100 leading-[90%] lg:leading-[120%] font-semibold w-[140px] h-[110px]">
          “
        </p>
        <span className="font-secondary text-[24px] lg:text-[38px] text-brand-primary leading-[120%] font-semibold -mt-6 lg:mt-0">
          {ApplyParagraphAnnotations(quote.value, quote.annotations)}
        </span>
      </div>
      {(quoteCredit?.value || quotee.value) && (
        <div
          className={twMerge(
            "lg:gap-5 text-sm font-medium text-neutral-700 leading-[150%]",
            flexCol,
          )}
        >
          <span>
            {ApplyParagraphAnnotations(quotee.value, quotee.annotations)}
          </span>
          {quoteCredit && quoteCredit.value && (
            <span>
              {ApplyParagraphAnnotations(
                quoteCredit.value,
                quoteCredit.annotations,
              )}
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export function PullQuoteCardMobile({
  quote,
  quotee,
  quoteLabel,
  quoteCredit,
}: PullQuoteCardProps) {
  const fiveNewlines = "\n\n\n\n\n\n";
  const threeNewlines = "\n\n\n";
  const twoNewlines = "\n\n";
  const oneNewline = "\n";

  return (
    <div className="mb-3 position-relative sidebar-quotebox paragraph paragraph--type-sidebar-quotebox paragraph--view-mode-default ds-1col clearfix">
      {quoteLabel && quoteLabel.value && (
        <>
          {fiveNewlines}
          <div className="pull-quote-title">
            {oneNewline}
            {ApplyParagraphAnnotations(
              quoteLabel.value,
              quoteLabel.annotations,
            )}
          </div>
          {fiveNewlines}
        </>
      )}
      {quote.value && (
        <>
          <div className="pull-quote-body">
            {oneNewline}
            {ApplyParagraphAnnotations(quote.value, quote.annotations)}
          </div>
          {fiveNewlines}
        </>
      )}
      {quotee.value && (
        <>
          <div className="pull-quote-source">
            {twoNewlines}
            <div className="field field--name-field-source-of-the-quote field--type-string-long field--label-hidden field__item">
              {ApplyParagraphAnnotations(quotee.value, quotee.annotations)}
            </div>
            {twoNewlines}
            {quoteCredit && quoteCredit.value && (
              <>
                <div className="field field--name-field-information-of-the-quote field--type-string-long field--label-hidden field__item">
                  {ApplyParagraphAnnotations(
                    quoteCredit.value,
                    quoteCredit.annotations,
                  )}
                </div>
                {twoNewlines}
              </>
            )}
          </div>
          {threeNewlines}
        </>
      )}
    </div>
  );
}
